import { useEffect, useState } from 'react';

import useTimer, { TimerProps } from '@/hooks/useTimer';

export interface MissionTimerProps extends TimerProps {
  targetTime: number;
}

export interface MissionTimer {
  time: number;
  displayTime: string;
  missionCompleted: boolean;
}
const useMissionTimer = ({
  targetTime,
  activated,
}: MissionTimerProps): MissionTimer => {
  const [missionCompleted, setMissionCompleted] = useState<boolean>(false);
  const { timer } = useTimer({ activated: activated && !missionCompleted });
  const displayTime = targetTime === timer ? '완료' : `${targetTime - timer}초`;

  useEffect(() => {
    if (timer === targetTime) {
      setMissionCompleted(true);
    }
  }, [timer]);

  return {
    time: timer,
    missionCompleted: missionCompleted,
    displayTime: displayTime,
  };
};

export default useMissionTimer;
